import Typography from '@mui/material/Typography';
import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Download from '@mui/icons-material/SimCardDownload';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { fetchSAWCList, fetchSAWC } from '../strapi';

function SAWC({ locale }) {
    const [sawc, setSawc] = useState({});
    const [sawcList, setSawcList] = useState([]);
    const API_URL = process.env.REACT_APP_STRAPI_URL;
    useEffect(() => {
        fetchSAWC(locale)
            .then(data => {
                setSawc(data);
               
            })
            .catch(err => {
            });
    }, [locale]);
    useEffect(() => {
        fetchSAWCList(locale)
            .then(data => {
                setSawcList(data);
            })
            .catch(err => {
            });
    }, [locale]);

    const onButtonClick = (url, name) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <div >
            <Container>
                <Typography className='titleOfPage' component="div" sx={{ mt: { xs: '', xl: '60px' }, pt: { xs: '80px', xl: '' }  }}>
                    {sawc.title}
                </Typography>
                <Grid container sx={{justifyContent: { xs: 'center', md: 'start' } }}>
                    {sawcList.map((item, index) => 
                        
                            <Paper key={index} sx={{ m: '10px', p: '30px', textAlign: 'center', maxWidth: '170px' }}>
                                <Typography sx={{ mb: '35px' }} gutterBottom variant="body1" centered component="div">
                                    {item.name}
                                </Typography>
                                <Download sx={{ fontSize: '100px', color: '#5281B5' }} onClick={() => onButtonClick(API_URL + item.document.url, item.name)}></Download>
                            </Paper>
                        
                    )}
                </Grid>
            </Container>
        </div>
    );
}

export default SAWC;
